import clsx from 'clsx';

import OtherPlaceBlock from '@/components/other-places-forecast/OtherPlaceBlock';
import { OtherPlaceForecast } from '@/models/OtherPlaceForecast';
import { AppConfig } from '@/utils/AppConfig';

const LG_ITEMS_LIMIT = 5;

type OtherPlacesForecastWidgetProps = {
  otherPlacesForecast: OtherPlaceForecast[];
};

const OtherPlacesForecastWidget = ({ otherPlacesForecast }: OtherPlacesForecastWidgetProps) => {
  if (!otherPlacesForecast.length) {
    return null;
  }

  const partnerHeaderPart = AppConfig.partner.isVl() ? 'Приморского края' : 'Хабаровского края';

  return (
    <div className="my-6 lg:my-14">
      <h2 className="mb-4 px-4 text-lg font-medium leading-6 text-grey-900 lg:mb-5 lg:px-0 lg:text-xl">
        Погода в других городах <span className="whitespace-nowrap">{partnerHeaderPart}</span>
      </h2>
      <div className="no-scrollbar flex snap-x scroll-px-4 flex-nowrap overflow-x-auto px-4 lg:scroll-px-0 lg:px-0 [&>*:last-child]:mr-0">
        {otherPlacesForecast.map((entry, index) => (
          <OtherPlaceBlock
            key={entry.placeSlug}
            otherPlaceForecast={entry}
            className={clsx(index >= LG_ITEMS_LIMIT && 'lg:hidden xl:block')}
          />
        ))}
      </div>
    </div>
  );
};

export default OtherPlacesForecastWidget;
